import { FeatureFlag } from '../FeatureFlag';

export const enableIdeaAlerts = new FeatureFlag({
    key: 'enable-idea-alerts',
    createdOn: '2026-03-09',
    defaultValue: false,
});
